// extracted by mini-css-extract-plugin
export default {"checkbox":"pOHp7uM83wxeztzr8nq3"};